import { db } from '../helpers/db'
import { isValidSession } from './session'

const defaultState = {
  user: {},
  redirect: false
}

const LOGIN = 'auth/LOGIN'
export const LOGOUT = 'auth/LOGOUT'
const REQUEST_SESSION = 'auth/REQUEST_SESSION'
const RECEIVE_SESSION = 'auth/RECEIVE_SESSION'
const REQUEST_SESSION_FAILURE = 'auth/REQUEST_SESSION_FAILURE'
const REQUEST_LOGIN_FAILURE = 'auth/REQUEST_LOGIN_FAILURE'

export default (state = defaultState, {type, ...actionProps}) => {
  switch (type) {
    case LOGIN:
    case LOGOUT:
    case RECEIVE_SESSION:
      return {
        ...state,
        ...actionProps,
        authenticationFailed: false
      }
    case REQUEST_LOGIN_FAILURE:
      return {
        ...state,
        authenticationFailed: actionProps.error
      }

    default:
      return state
  }
}

const loginAction = user => ({
  user,
  type: LOGIN,
  redirect: true
})

export const toggleLoginError = () => (dispatch, getState) => {
  const loginState = getState().auth.authenticationFailed || false
  dispatch({
    type: REQUEST_LOGIN_FAILURE,
    error: !loginState
  })
}

export const login = (username, password) => dispatch =>
  db.login(username, password)
    .then(user => {
      dispatch(loginAction(user))
    })
    .catch(() => dispatch(toggleLoginError()))

export const logout = () => dispatch =>
  db.logout()
    .then(() => dispatch({ type: LOGOUT, ...defaultState }))

export const getSession = () => dispatch => {
  dispatch({ type: REQUEST_SESSION })
  return db.getSession()
    .then(session => {
      const validSession = isValidSession(session)
      if (!validSession) {
        return dispatch({ type: REQUEST_SESSION_FAILURE })
      }
      dispatch({
        ok: true,
        type: RECEIVE_SESSION,
        user: session.userCtx
      })
    })
    .catch(() => dispatch({ type: REQUEST_SESSION_FAILURE }))
}

export const getSessionFromVAS = getSession => dispatch => {
  dispatch({ type: REQUEST_SESSION })
  return getSession()
    .then(user => {
      dispatch({
        user,
        ok: true,
        type: RECEIVE_SESSION
      })
    })
    .catch(() => dispatch({ type: REQUEST_SESSION_FAILURE }))
}



// WEBPACK FOOTER //
// ./src/login/auth-reducer.js